import { render, staticRenderFns } from "./addOrDebitScore.vue?vue&type=template&id=b744abea&scoped=true&"
import script from "./addOrDebitScore.vue?vue&type=script&lang=js&"
export * from "./addOrDebitScore.vue?vue&type=script&lang=js&"
import style0 from "./addOrDebitScore.vue?vue&type=style&index=0&id=b744abea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b744abea",
  null
  
)

export default component.exports